import { Bonus } from '../communication/PlayerApiProtocol.generated'
import { CurrencyCode } from '../constants'
import { AsyncState } from '../redux/ReduxUtils'


export interface AccountBalance {
	amount: number
	currencyCode: CurrencyCode
	formattedBalance: string
	role: CurrencyRole
}

export enum CurrencyRole {
	main = 'MAIN',
	bonus = 'BONUS'
}

export interface AccountState extends AsyncState {
	balances?: AccountBalance[]
	bonuses?: Bonus[]
	refreshable?: boolean
	lastUpdateTimeStamp?: number
	balanceHidden?: boolean
}
